<div class="grip">
  <div class="col-12">
    <div class="text-center p-3">
      <p-tabMenu
        [model]="items"
        [(activeItem)]="activeItem"
        (onChange)="tabChange($event)"
      ></p-tabMenu>

      <div *ngIf="activeItem.label === tabLabels.trending">
        <div *ngFor="let item of trendingBlogs">
          <app-trending-card
            [blogId]="item.blogId"
            [heading]="item.heading"
            [topicName]="item.topicName"
            [shortTitle]="item.shortTitle"
            [readTime]="item.readTime"
          ></app-trending-card>
        </div>
      </div>

      <div *ngIf="activeItem.label === tabLabels.featured">
        <div *ngFor="let item of featuredBlogs">
          <app-trending-card
            [blogId]="item.blogId"
            [heading]="item.heading"
            [topicName]="item.topicName"
            [shortTitle]="item.shortTitle"
            [readTime]="item.readTime"
          ></app-trending-card>
        </div>
      </div>
    </div>
  </div>
</div>
